import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Envelope, Users, Article, MagnifyingGlass } from "@phosphor-icons/react";

export default function AdminDashboard() {
  const [leads, setLeads] = useState([]);
  const [partners, setPartners] = useState([]);

  useEffect(() => {
    api.get("/leads").then((r) => setLeads(r.data || []));
    api.get("/partners").then((r) => setPartners(r.data || []));
  }, []);

  const unread = leads.filter((l) => !l.read).length;

  const cards = [
    { label: "Demandes reçues", value: leads.length, sub: `${unread} non lues`, icon: Envelope, to: "/admin/leads" },
    { label: "Partenaires", value: partners.length, sub: "actifs", icon: Users, to: "/admin/partenaires" },
    { label: "Contenus éditables", value: "Tous", sub: "personnaliser les textes", icon: Article, to: "/admin/contenus" },
    { label: "SEO", value: "9 pages", sub: "balises & meta", icon: MagnifyingGlass, to: "/admin/seo" },
  ];

  return (
    <div data-testid="admin-dashboard" className="p-8 md:p-10">
      <div className="label-caps mb-3">Vue d'ensemble</div>
      <h1 className="font-serif text-3xl md:text-4xl text-ducs-cream">Bienvenue</h1>
      <p className="text-ducs-mist mt-2">Pilotage complet du site Courtage des Ducs.</p>

      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5 mt-10">
        {cards.map((c) => {
          const Icon = c.icon;
          return (
            <Link to={c.to} key={c.label} className="card-ducs p-6 block">
              <Icon size={26} weight="duotone" className="text-ducs-gold" />
              <div className="mt-5 text-3xl font-serif text-ducs-cream">{c.value}</div>
              <div className="label-caps mt-2">{c.label}</div>
              <div className="text-xs text-ducs-mist mt-1">{c.sub}</div>
            </Link>
          );
        })}
      </div>

      <div className="mt-12">
        <div className="flex items-center justify-between">
          <h2 className="font-serif text-2xl text-ducs-cream">Dernières demandes</h2>
          <Link to="/admin/leads" className="text-sm text-ducs-gold hover:underline">Voir toutes</Link>
        </div>
        <div className="mt-5 card-ducs">
          <table className="w-full text-sm">
            <thead className="text-left text-ducs-mist text-xs uppercase tracking-wider">
              <tr>
                <th className="px-5 py-3">Date</th>
                <th className="px-5 py-3">Nom</th>
                <th className="px-5 py-3">Besoin</th>
                <th className="px-5 py-3">Statut</th>
              </tr>
            </thead>
            <tbody>
              {leads.slice(0, 6).map((l) => (
                <tr key={l.id} className="border-t border-ducs-gold/10">
                  <td className="px-5 py-3 text-ducs-mist">{new Date(l.created_at).toLocaleDateString("fr-FR")}</td>
                  <td className="px-5 py-3">{l.prenom} {l.nom}</td>
                  <td className="px-5 py-3 text-ducs-cream/80">{l.besoin}</td>
                  <td className="px-5 py-3">
                    {l.read ? (
                      <span className="text-ducs-mist">Lue</span>
                    ) : (
                      <span className="text-ducs-gold">Nouvelle</span>
                    )}
                  </td>
                </tr>
              ))}
              {leads.length === 0 && (
                <tr><td colSpan={4} className="px-5 py-6 text-center text-ducs-mist">Aucune demande pour le moment.</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
